import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  assetsTableContainer: {
    marginTop: "5px",
    overflowX: "auto",
    overflowY: "auto",
    width: "100%",
  },
  table: {
    width: "100%",
  },
  tableCustomView: {
    width: "max-content !important",
    minWidth: "100%",
    tableLayout: "auto",
    "& .MuiTableCell-root": {
      width: "max-content",
      maxWidth: "250px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  },
  tableHeaderCustom: {
    backgroundColor: theme.palette.primary.main,
  },
  tableRow: {
    borderCollapse: "collapse",
  },
  headTableCustom: {
    padding: "10px 5px!important",
    color: `${theme.palette.text.tertiary} !important`,
    backgroundColor: `${theme.palette.primary.main} !important`,
    zIndex: "3",
    width: "180px !important",
    borderBottom: `1px solid ${theme.palette.text.tertiary} !important`,
    fontSize: "14px !important",
  },
  assetsListModals: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  listTextCustom: {
    color: theme.palette.text.primary,
    padding: "10px 5px",
    minWidth: "150px",
    width: "auto",
    flex: "1 1 auto",
    borderBottom: `1px solid ${theme.palette.text.tertiary}`,
  },
  flexGap5: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "5px",
  },
  inlineButtons: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "8px",
  },
  shotVersionPageModals: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export default useStyles;
